import type { ServiceDictionary } from '@ngb-frontend/shared/types'

export const APP_SERVICES: ServiceDictionary = {
  services: ['RegularMaintenance', 'Repair', 'MOT'],
  'extra-services': [
    'PickupAndReturn',
    'ReplacementVehicle',
    'ComplementaryCleaning',
  ],
}
